import React from "react";
import moment from "moment";
import { Divider, Grid, Stack } from "@mui/material";

import { fixedDigitsAfterDecimal } from "../../../../utils";
import CustomizedProgressBars from "../../../board/components/progressBar/ProgressBar";
import lateIcon from "../../../../styles/svg/warning-icon.svg";

export const ByTaskMobileProgressBar = ({ card = [], isSameDay }) => {
  return (
    <Grid
      item
      xs={12}
      md={3}
      sx={{
        paddingLeft: "4px !important",
        paddingRight: "4px !important",
      }}>
      {/* <p className="worklog-title mr-2 ml-2">{card[0]?.cardlog?.card?.title}</p> */}
      {card &&
        card.map((cardDetails, index) => (
          <div
            key={`by-task-mobile-progress-${index}`}
            className={index === 0 ? "mt-2" : "mt-11"}>
            <Stack direction={"row"}>
              <p
                className="worklog-date-time"
                style={{ justifyContent: "left" }}>
                {!isSameDay(
                  cardDetails?.cardlog?.created_at,
                  cardDetails?.cardlog?.date_time
                ) && (
                  <img src={lateIcon} className="late-icon" alt="late-icon" />
                )}
                {moment
                  .utc(cardDetails?.cardlog?.date_time)
                  .local()
                  .format("MMMM D, YYYY [at] h:mm A")}
              </p>

              <Divider
                orientation="vertical"
                variant="middle"
                flexItem
                className="ml-1 mr-6 mt-0 mb-0"
                sx={{ height: "14px", width: "2px" }}
              />
              <p className="worklog-date-time">
                {`${
                  cardDetails?.cardlog?.hours_spent == 1
                    ? `${cardDetails?.cardlog?.hours_spent}Hour`
                    : `${cardDetails?.cardlog?.hours_spent} Hours`
                }`}
              </p>
            </Stack>
            <p
              className="worklog-worklog mt-0"
              dangerouslySetInnerHTML={{
                __html: cardDetails?.cardlog?.work_performed,
              }}></p>
          </div>
        ))}
      <div className="mt-2">
        <CustomizedProgressBars
          allocatedHours={card[0]?.cardlog?.card?.allocated_hours}
          hoursSpent={fixedDigitsAfterDecimal(
            card.reduce(
              (sum, cardDetails) => sum + cardDetails?.cardlog?.hours_spent,
              0
            )
          )}
          hideDate={true}
        />
      </div>
    </Grid>
  );
};
